<template>
  <div class="form-group">
    <label
      :for="inputId"
      class="mb-1"
    >
      {{ label }}
      <span
        v-if="sublabel"
        class="fw-normal"
      >
        {{ sublabel }}
      </span>
    </label>
    <div
      v-if="description"
      class="d-flex text-gray-700 fs-14 mb-2"
    >
      {{ description }}
    </div>
    <div class="input-group">
      <input
        :id="inputId"
        v-directive="{
          getValue: customValue,
          setValue: setCustomModel,
          update: updateObject,
          mask,
        }"
        class="form-control bg-white"
        :class="[validationClass, { 'input-currency': mask === 'currency' },
                 { 'disabled-bg': inputDisabled }]"
        :type="inputType"
        :disabled="inputDisabled"
        :readonly="readonly"
        :placeholder="placeholder"
        @focus="(event) => $emit('focus', event)"
        @blur="(event) => $emit('blur', event)"
      >
      <slot name="input-append" />
    </div>
    <div
      v-if="isValid === false && errorMessage"
      class="text-danger small mt-1"
    >
      {{ errorMessage }}
    </div>
  </div>
</template>
<script>
import directive from '@/directives/mask2';
import input from '@/mixins/input-2';

export default {
  name: 'CommonInput',
  directives: {
    directive,
  },
  mixins: [input],
  props: {
    errorMessage: {
      type: String,
      default: null,
    },
    mask: {
      type: String,
      default: 'all',
    },
    description: {
      type: [String, null],
      default: null,
    },
    readonly: {
      type: [Boolean, null],
      default: false,
    },
    sublabel: {
      type: String,
      default: '',
    },
    inputDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      updateObject: {
        allow: true,
        forceUpdate: () => {},
      },
    };
  },
  computed: {
    inputType() {
      let type = 'text';
      switch (this.mask) {
        case 'search':
          type = 'search';
          break;
        case 'number':
        case 'currency':
        case 'tel':
          type = 'tel';
          break;
        case 'email':
        case 'password':
          type = this.mask;
          break;
        default:
          break;
      }
      return type;
    },
  },
  watch: {
    storeValue: {
      handler(value) {
        if (value !== this.customValue) {
          this.updateObject.forceUpdate(value);
        }
      },
    },
  },
};
</script>

<style scoped>
.disabled-bg {
  background-color: #e9ecef !important;
}
</style>
